import { reportsInstance } from '@/common/service/api/Axios';

export const trackActivity_view = async (data: { activityId: string; partnerId: string }) => {
    try {
        reportsInstance.post('', {
            eventType: 'activity_view',
            data,
        });
    } catch (error) {
        console.log((error as Error).message);
    }
};
export const trackActivity_list_view = async (
    data: {
        activityId: string;
        partnerId: string;
        position: number;
    }[]
) => {
    try {
        reportsInstance.post('', {
            events: data.map((i) => ({
                eventType: 'activity_list_view',
                data: i,
            })),
        });
    } catch (error) {
        console.log((error as Error).message);
    }
};
export const trackActivity_promotion_select = async (data: {
    activityId: string;
    partnerId: string;
}) => {
    try {
        reportsInstance.post('', {
            eventType: 'activity_promotion_select',
            data,
        });
    } catch (error) {
        console.log((error as Error).message);
    }
};
export const trackActivity_promotion_view = async (
    data: {
        activityId: string;
        partnerId: string;
    }[]
) => {
    try {
        reportsInstance.post('', {
            events: data.map((i) => ({
                eventType: 'activity_promotion_view',
                data: i,
            })),
        });
    } catch (error) {
        console.log((error as Error).message);
    }
};
export const trackActivity_promotion_purchase = async (
    data: {
        activityId: string;
        partnerId: string;
        total: number;
    }[]
) => {
    try {
        reportsInstance.post('', {
            events: data.map((i) => ({
                eventType: 'activity_promotion_purchase',
                data: i,
            })),
        });
    } catch (error) {
        console.log((error as Error).message);
    }
};
